import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {
    Box,
    Button,
    Divider,
    Paper,
    Typography,
} from '@mui/material';
import React from 'react';

const AutoSaves = ({ checkpointsContent, handleAutoSaveLoad, tabHeight }) => {
    const handleCheckpointClick = (epochTime) => {
        handleAutoSaveLoad(epochTime);
    };

    return (
        <Box
            sx={{
                height: `calc(100vh - ${tabHeight})`,
                overflowY: 'auto',
                px: 2,
                py: 1,
            }}
        >
            {checkpointsContent.length > 0 ? (
                checkpointsContent.map((checkpoint, index) => (
                    <Paper
                        key={index}
                        variant="outlined"
                        sx={{
                            mb: 2,
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        }}
                    >
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box display="flex" alignItems="center">
                                <AccessTimeIcon fontSize="small" sx={{ mr: 1 }} />
                                <Typography variant="subtitle2">
                                    {checkpoint.human_readable_time}
                                </Typography>
                            </Box>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => handleCheckpointClick(checkpoint.epoch_time)}
                            >
                                Load
                            </Button>
                        </Box>
                        <Divider />
                        <Typography
                            variant="body2"
                            sx={{ fontStyle: 'italic', mt: 1 }}
                            color="text.secondary"
                        >
                            {checkpoint.last_message.length > 50
                                ? `${checkpoint.last_message.slice(0, 50)}...`
                                : checkpoint.last_message}
                        </Typography>
                    </Paper>
                ))
            ) : (
                <Typography textAlign="center" mt={2}>
                    No auto saves available.
                </Typography>
            )}
        </Box>
    );
};

export default AutoSaves;
